import React from 'react';
import WorkerList from '../../components/WorkerComponents/WorkerList'; 
import ValuatorNavbar from '../../components/ValuatorNavbar';


const WorkersPage = () => {

  return (
    <div>
        <ValuatorNavbar />
        <WorkerList />      
    </div>
  );
};

export default WorkersPage;
